export default "__VITE_ASSET__D7F8cb2E__"